import { Container } from "@amzn/stencil-react-components/layout";
import { FormattedMessage } from "react-intl";

import { BulletList } from "@/components/Commons/BulletList";

import PreCacheADAcmeCatalog from "../../assets/images/preCacheADAcmeCatalog.png";
import PreCacheAdAcmeInstall from "../../assets/images/preCacheAdAcmeInstall.png";
import PreCacheADAcmeLogo from "../../assets/images/preCacheADAcmeLogo.png";
import PreCacheADAcmeSearch from "../../assets/images/preCacheADAcmeSearch.png";
import PreCacheADAcmeSuccess from "../../assets/images/preCacheADAcmeSuccess.png";
import PreCacheADAcmeSync from "../../assets/images/preCacheADAcmeSync.png";
import PreCacheADPassword from "../../assets/images/preCacheADPassword.png";
import PreCacheADSearch from "../../assets/images/preCacheADSearch.png";
import PreCacheADSignIn from "../../assets/images/preCacheADSignIn.png";
import PreCacheADSuccess from "../../assets/images/preCacheADSuccess.png";
import PreCacheADUsername from "../../assets/images/preCacheADUsername.png";
import { StepsList } from "../constants";

/**
 * Mapping of proper nouns that should not be translates so they are included
 * in the text as variables.
 */
export const StepListLiterals = {
  selfServiceText: "Self Service",
  preCacheText: "Pre-Cache",
  preCacheMobileAccountText: "Pre-Cache AD Mobile Account",
  showAcmeWindowText: "Show ACME Window",
  softwareCatalogText: "Software Catalog",
  syncAccountText: "Sync Account",
  ciscoClientAppName: "Cisco Secure Client",
  vpnText: "VPN",
  groupText: "Group",
  orcaVPNText: "orca-Amazon-Onboarding",
};

export const StepListWindows: StepsList[] = [
  { stepLocaleId: "preCacheADMobile-expander-body-step1" },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step2",
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step3",
    image: {
      src: PreCacheADSignIn,
      altTextLocaleId: "preCacheADMobile-image-step3-altText",
      widthPx: 457,
      heightPx: 303,
    },
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step4",
    image: {
      src: PreCacheADSearch,
      altTextLocaleId: "preCacheADMobile-image-step4-altText",
      widthPx: 650,
      heightPx: 422,
    },
  },
  { stepLocaleId: "preCacheADMobile-expander-body-step5" },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step6",
    image: {
      src: PreCacheADUsername,
      altTextLocaleId: "preCacheADMobile-image-step6-altText",
      widthPx: 334,
      heightPx: 143,
    },
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step7",
    image: {
      src: PreCacheADPassword,
      altTextLocaleId: "preCacheADMobile-image-step7-altText",
      widthPx: 340,
      heightPx: 151,
    },
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step8",
    image: {
      src: PreCacheADSuccess,
      altTextLocaleId: "preCacheADMobile-image-step8-altText",
      widthPx: 426,
      heightPx: 148,
    },
  },
];

export const StepListMac: StepsList[] = [
  {
    stepLocaleId: "preCacheADMobile-expander-body-step1-mac",
    image: {
      src: PreCacheADAcmeLogo,
      altTextLocaleId: "preCacheADMobile-image-step1-altText-mac",
      widthPx: 464,
      heightPx: 386,
    },
    children: (
      <Container paddingTop={"S400"}>
        <FormattedMessage
          values={{
            b: (chunk: unknown) => <b>{chunk}</b>,
            ...StepListLiterals,
          }}
          id="preCacheADMobile-expander-body-step1-mac-note"
        />
      </Container>
    ),
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step2-mac",
    image: {
      src: PreCacheADAcmeCatalog,
      altTextLocaleId: "preCacheADMobile-image-step2-altText-mac",
      widthPx: 720,
      heightPx: 862,
    },
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step3-mac",
    image: {
      src: PreCacheADAcmeSearch,
      altTextLocaleId: "preCacheADMobile-image-step3-altText-mac",
      widthPx: 704,
      heightPx: 518,
    },
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step4-mac",
    image: {
      src: PreCacheAdAcmeInstall,
      altTextLocaleId: "preCacheADMobile-image-step4-altText-mac",
      widthPx: 706,
      heightPx: 238,
    },
    children: (
      <Container paddingTop="S300">
        <FormattedMessage
          values={{
            ...StepListLiterals,
          }}
          id="preCacheADMobile-expander-body-step4-mac-note"
        />
        <BulletList
          dataTestId="preCacheADMobile-expander-body-step4-mac-note-lists"
          i18nIds={Array.from(
            { length: 8 },
            (_, i) =>
              `preCacheADMobile-expander-body-step4-mac-note-list${i + 1}`
          )}
          stringLiterals={StepListLiterals}
        />
      </Container>
    ),
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step5-mac",
    image: {
      src: PreCacheADAcmeSync,
      altTextLocaleId: "preCacheADMobile-image-step5-altText-mac",
      widthPx: 702,
      heightPx: 560,
    },
    children: (
      <Container paddingTop={"S400"}>
        <FormattedMessage
          values={{
            b: (chunk: unknown) => <b>{chunk}</b>,
            ...StepListLiterals,
          }}
          id="preCacheADMobile-expander-body-step5-mac-note"
        />
      </Container>
    ),
  },
  {
    stepLocaleId: "preCacheADMobile-expander-body-step6-mac",
    image: {
      src: PreCacheADAcmeSuccess,
      altTextLocaleId: "preCacheADMobile-image-step6-altText-mac",
      widthPx: 474,
      heightPx: 384,
    },
  },
];
